/* eslint-disable i18n/no-russian-character */

import type { NotificationItem } from '@/api/backend/contract/Notification';

/** Моки для UI-превью в development */
export const MOCK_NOTIFICATIONS: NotificationItem[] = [
  {
    id: 'mock-1',
    title: 'Жаркая выгода!',
    body: 'Украшения со скидкой 60% в разделе «РАСПРОДАЖА» Сверкающие спирали, романтичные сердца и милые банты',
    createdAt: '2026-06-30T14:20:00+03:00',
    isRead: true,
    action: {
      label: 'Смотреть',
      url: '/catalog'
    }
  },
  {
    id: 'mock-2',
    title: 'Серьги за 13 990 ₽',
    body: 'Лучшая цена на золотые пусеты с чарующим изумрудом Капля застывшей магии в безупречных линиях',
    createdAt: '2026-06-30T14:20:00+03:00',
    isRead: false,
    action: {
      label: 'Смотреть',
      url: '/catalog'
    }
  },
  {
    id: 'mock-3',
    title: 'Подарите восторг',
    body: 'на выпускной, день рождения или без повода Эксклюзивное украшение и шанс найти карту на 30 000 ₽',
    createdAt: '2026-06-30T12:05:00+03:00',
    isRead: true,
    action: {
      label: 'Смотреть',
      url: '/catalog'
    }
  },
  {
    id: 'mock-4',
    title: 'Заказ №45821 передан в доставку',
    body: 'Курьер свяжется с вами в день доставки. Ожидаемая дата — 1 июля',
    createdAt: '2026-06-29T18:40:00+03:00',
    isRead: false,
    action: {
      label: 'Подробнее',
      url: '/account/orders'
    }
  },
  {
    id: 'mock-5',
    title: 'Заказ №45821 собран',
    body: 'Ваш заказ упакован и готов к передаче в службу доставки',
    createdAt: '2026-06-29T11:15:00+03:00',
    isRead: true,
    action: {
      label: 'Подробнее',
      url: '/account/orders'
    }
  },
  {
    id: 'mock-6',
    title: 'UVI Jewellery в МФК «Афи Галерея»',
    body: 'г. Ростов-на-Дону, Кировоградская, 13А\n+7 495 644-29-80\nСтоимость — бесплатно\nг. Москва, площадь Тверская застава, д. 4\n1 этаж, вход с площади Тверской заставы, поворот налево\nпн–пт: 10:00-21:00, сб–вс: 10:00–20:00',
    createdAt: '2026-06-28T09:30:00+03:00',
    isRead: false,
    action: {
      label: 'Подробнее',
      url: '/addresses'
    }
  }
];
